import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import AuthenticationLayout from '../layouts/AuthenticationLayout.vue';
import LoginPage from '../pages/Authentication/LoginPage.vue';
import ForgotPasswordPage from '../pages/Authentication/ForgotPasswordPage.vue';
import DashBoardLayout from '../layouts/DashboardLayout.vue';
import HomePage from '../pages/Dashboard/HomePage.vue';
import NotFound from '../pages/NotFoundPage.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '',
    name: 'authentication',
    component: AuthenticationLayout,
    children: [
      {
        path: '',
        name: 'authentication.login',
        component: LoginPage,
        meta: { requiresAuth: false },
      },
      {
        path: 'forgot-password',
        name: 'authentication.forgot-password',
        component: ForgotPasswordPage,
        meta: { requiresAuth: false },
      },
    ],
  },
  {
    path: '',
    name: 'authenticated',
    component: DashBoardLayout,
    children: [
      {
        path: '',
        name: 'authenticated.home',
        component: HomePage,
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: '/404',
    name: 'notfound',
    component: NotFound,
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/404',
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const tokensAreSet = localStorage.getItem('token') !== null;

  if (to.meta.requiresAuth) {
    if (tokensAreSet) {
      next();
    } else {
      router.push({ name: 'authentication.login' });
    }
  } else {
    if (tokensAreSet) {
      router.push({ name: 'authenticated.home' });
    } else {
      next();
    }
  }
});

export default router;
